export default {
    profileSetData: { method: 'post', url: 'api/guests/data' },
    profileGetData: { method: 'get', url: 'api/guests/data' },
    revokeWispot: { method: 'post', url: 'api/guests/revoke/wispot' }
}

